import { render } from "./qxcwei.vue?vue&type=template&id=1d3fb1b2&scoped=true"
import script from "./qxcwei.vue?vue&type=script&lang=js"
export * from "./qxcwei.vue?vue&type=script&lang=js"

import "./qxcwei.vue?vue&type=style&index=0&id=1d3fb1b2&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3fb1b2"]])

export default __exports__